// all of this is necessary to make sure that the bracket is built with the correct team on top and
// the correct team on the bottom (by paying attention to who won in the previous round)

import * as utilities from './utilities';
import * as manageData from './manageData';
import * as htmlBuilder from './htmlBuilder';

const leftBar = document.getElementById('LeftBar');

function hasVideoAvailable(match) {
    if (!match || !match.matchCompleted) return false;
    if (match.youTubeID) return true;
    if (match.sportMonksVideoLink) return true;
    if (settings.globals.currentTourny.buildVideoLink) return true;
    return false;
}

function getBracketInfo(slot, row, infoNeeded, isRightSide32Team = false) {
    let teamNeeded = null;
    let theCurrentMatch = null;
    let thePreviousMatch = null;
    let textNeeded = null;
    let theTeamID = null;
    let theAltText = null;
    let waitingForSlot = null; // Track which slot we're waiting for the winner from
    if (row % 2 === 1) teamNeeded = 'teamOne';
    theCurrentMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === slot);
    // Check tournament formats first (needed for subsequent rounds logic)
    const isThreeRoundsToEight = settings.globals.currentTourny.scheduleFormat === 'threeRoundsToEightKnockOut';
    const isFiveRoundsToEight = settings.globals.currentTourny.scheduleFormat === 'fiveRoundsToEightKnockOut';
    const isThreeRoundsToThirtyTwo = settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';

    // Check if this is a subsequent round that looks back to previous rounds
    // For 8-team brackets, r8-* is the FIRST round (not subsequent), so only r4-* and r2 are subsequent
    const isSubsequentRound =
        slot &&
        (isThreeRoundsToThirtyTwo
            ? slot.startsWith('r16-') || slot.startsWith('r8-') || slot.startsWith('r4-') || slot === 'r2'
            : isThreeRoundsToEight || isFiveRoundsToEight
                ? slot.startsWith('r4-') || slot === 'r2' // For 8-team brackets, r8-* is the first round
                : slot.startsWith('r8-') || slot.startsWith('r4-') || slot === 'r2'); // For 16-team brackets

    // For subsequent rounds, we need to process them even if theCurrentMatch is undefined
    // because we need to determine waitingForSlot
    if (theCurrentMatch === undefined && !isSubsequentRound) {
        utilities.myErrorReport('location 1 ' + 'match not for round: ', slot);
        // If match doesn't exist yet and it's not a subsequent round, set TBD and return early
        // BUT: For flags in 32-team bracket, we still want to show the flag even if match doesn't exist
        if (infoNeeded === 'name') {
            return 'TBD';
        }
        // For flags, don't return early if it's a 32-team bracket - we want to show the USA flag
        if (infoNeeded === 'flag') {
            const isThreeRoundsToThirtyTwo =
                settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
            if (isThreeRoundsToThirtyTwo) {
                // Continue to flag section below to show USA flag
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    if (theCurrentMatch !== undefined) {
        if (
            //round of 32 (only exists in threeRoundsToThirtyTwoKnockOut)
            (isThreeRoundsToThirtyTwo && slot && slot.startsWith('r32-')) ||
            //round of 16 (only exists in threeRoundsToSixteenKnockOut)
            (!isThreeRoundsToThirtyTwo &&
                (slot === 'r16-1' ||
                    slot === 'r16-2' ||
                    slot === 'r16-3' ||
                    slot === 'r16-4' ||
                    slot === 'r16-5' ||
                    slot === 'r16-6' ||
                    slot === 'r16-7' ||
                    slot === 'r16-8')) ||
            //round of 8 (treat like r16 - get teams directly from match)
            ((isThreeRoundsToEight || isFiveRoundsToEight) &&
                (slot === 'r8-1' || slot === 'r8-2' || slot === 'r8-3' || slot === 'r8-4'))
        ) {
            if (teamNeeded === 'teamOne') {
                theTeamID = theCurrentMatch.teamOneID;
                theAltText = theCurrentMatch.teamOneAltText;
            } else {
                theTeamID = theCurrentMatch.teamTwoID;
                theAltText = theCurrentMatch.teamTwoAltText;
            }
        }
    }

    // Handle subsequent rounds (R16, R8, R4, R2) - these look back to previous rounds
    // This needs to run even if theCurrentMatch is undefined (matches may not exist yet)
    if (isSubsequentRound) {
        //subsequent rounds
        if (isThreeRoundsToThirtyTwo) {
            // For threeRoundsToThirtyTwoKnockOut: r16 looks back to r32, r8 looks back to r16, etc.
            if (slot === 'r16-1' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-1');
            } else if (slot === 'r16-1') {
                waitingForSlot = 'r32-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-2');
            } else if (slot === 'r16-2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-3';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-3');
            } else if (slot === 'r16-2') {
                waitingForSlot = 'r32-4';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-4');
            } else if (slot === 'r16-3' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-5';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-5');
            } else if (slot === 'r16-3') {
                waitingForSlot = 'r32-6';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-6');
            } else if (slot === 'r16-4' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-7';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-7');
            } else if (slot === 'r16-4') {
                waitingForSlot = 'r32-8';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-8');
            } else if (slot === 'r16-5' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-9';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-9');
            } else if (slot === 'r16-5') {
                waitingForSlot = 'r32-10';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-10');
            } else if (slot === 'r16-6' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-11';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-11');
            } else if (slot === 'r16-6') {
                waitingForSlot = 'r32-12';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-12');
            } else if (slot === 'r16-7' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-13';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-13');
            } else if (slot === 'r16-7') {
                waitingForSlot = 'r32-14';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-14');
            } else if (slot === 'r16-8' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r32-15';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-15');
            } else if (slot === 'r16-8') {
                waitingForSlot = 'r32-16';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r32-16');
            } else if (slot === 'r8-1' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-1');
            } else if (slot === 'r8-1') {
                waitingForSlot = 'r16-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-2');
            } else if (slot === 'r8-2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-3';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-3');
            } else if (slot === 'r8-2') {
                waitingForSlot = 'r16-4';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-4');
            } else if (slot === 'r8-3' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-5';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-5');
            } else if (slot === 'r8-3') {
                waitingForSlot = 'r16-6';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-6');
            } else if (slot === 'r8-4' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-7';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-7');
            } else if (slot === 'r8-4') {
                waitingForSlot = 'r16-8';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-8');
            } else if (slot === 'r4-1' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r8-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-1');
            } else if (slot === 'r4-1') {
                waitingForSlot = 'r8-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-2');
            } else if (slot === 'r4-2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r8-3';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-3');
            } else if (slot === 'r4-2') {
                waitingForSlot = 'r8-4';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-4');
            } else if (slot === 'r2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r4-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r4-1');
            } else if (slot === 'r2') {
                waitingForSlot = 'r4-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r4-2');
            }
        } else if (isThreeRoundsToEight || isFiveRoundsToEight) {
            // For 8-team brackets: r4 looks back to r8 (r8 is the first round), r2 looks back to r4
            if (slot === 'r4-1' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r8-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-1');
            } else if (slot === 'r4-1') {
                waitingForSlot = 'r8-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-2');
            } else if (slot === 'r4-2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r8-3';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-3');
            } else if (slot === 'r4-2') {
                waitingForSlot = 'r8-4';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-4');
            } else if (slot === 'r2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r4-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r4-1');
            } else if (slot === 'r2') {
                waitingForSlot = 'r4-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r4-2');
            }
        } else {
            // For threeRoundsToSixteenKnockOut: r8 looks back to r16, r4 looks back to r8, etc.
            if (slot === 'r8-1' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-1');
            } else if (slot === 'r8-1') {
                waitingForSlot = 'r16-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-2');
            } else if (slot === 'r8-2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-3';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-3');
            } else if (slot === 'r8-2') {
                waitingForSlot = 'r16-4';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-4');
            } else if (slot === 'r8-3' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-5';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-5');
            } else if (slot === 'r8-3') {
                waitingForSlot = 'r16-6';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-6');
            } else if (slot === 'r8-4' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r16-7';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-7');
            } else if (slot === 'r8-4') {
                waitingForSlot = 'r16-8';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r16-8');
            } else if (slot === 'r4-1' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r8-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-1');
            } else if (slot === 'r4-1') {
                waitingForSlot = 'r8-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-2');
            } else if (slot === 'r4-2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r8-3';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-3');
            } else if (slot === 'r4-2') {
                waitingForSlot = 'r8-4';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r8-4');
            } else if (slot === 'r2' && teamNeeded === 'teamOne') {
                waitingForSlot = 'r4-1';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r4-1');
            } else if (slot === 'r2') {
                waitingForSlot = 'r4-2';
                thePreviousMatch = settings.globals.currentMatches.find((k) => k.bracketSlot === 'r4-2');
            }
        }

        if (thePreviousMatch === undefined) {
            utilities.myErrorReport('location 2 ' + 'match not for round: ', slot);
            // For subsequent rounds, always use waitingForSlot if it's set
            if (waitingForSlot) {
                theTeamID = null; // Use null to trigger "Winner [slot]" display
            } else {
                theTeamID = 'TBD';
            }
        } else if (!thePreviousMatch.matchCompleted) {
            // Keep waitingForSlot set so we can show "Winner [slot]"
            theTeamID = null; // Use null to indicate we're waiting for a winner
        } else {
            if (thePreviousMatch.teamOneScore > thePreviousMatch.teamTwoScore) {
                theTeamID = thePreviousMatch.teamOneID;
            } else {
                theTeamID = thePreviousMatch.teamTwoID;
            }
        }
    }

    if (infoNeeded === 'name') {
        // TEMPORARY: Keep original name logic for now
        if (theTeamID === 'TBD' || theTeamID === null || theTeamID === undefined) {
            // For subsequent rounds, ALWAYS show "Winner [slot]" if waitingForSlot is set
            if (waitingForSlot) {
                textNeeded = 'Winner ' + waitingForSlot;
            } else if (theAltText) {
                textNeeded = theAltText;
            } else {
                textNeeded = 'TBD';
            }
        } else {
            textNeeded = manageData.getProperEntityName(theTeamID);
        }
    }

    if (infoNeeded === 'score') {
        // TEMPORARY: Hard code "0*" for 32-team bracket only, leave others as-is
        const isThreeRoundsToThirtyTwo =
            settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
        if (isThreeRoundsToThirtyTwo) {
            textNeeded = '0*';

            // Hard code video icon for each slot in 32-team bracket
            // Add video icon based on slot number:
            // - Odd-numbered slots (1, 3, 5, 7, etc.): icon in top row (row % 2 === 1)
            // - Even-numbered slots (2, 4, 6, 8, etc.): icon in second row (row % 2 === 0)
            // Exception: r4-2 should have icon in top row for aesthetic reasons
            // Extract slot number from slot string (e.g., "r16-1" → 1, "r8-2" → 2, "r2" → treat as 1)
            let slotNumber = 1; // Default for final (r2)
            if (slot && slot.includes('-')) {
                const slotParts = slot.split('-');
                if (slotParts.length > 1) {
                    slotNumber = parseInt(slotParts[1], 10) || 1;
                }
            }
            const isOddSlot = slotNumber % 2 === 1;
            // Special case: r2 (final) for 32-team bracket should show icon in top row (row 5) only
            // Check final FIRST before other special cases
            const isFinal32Team = slot === 'r2';
            // Special case: r4-2 should have icon in top row (row % 2 === 1)
            const isR42 = slot === 'r4-2';
            const shouldShowIcon = isFinal32Team
                ? row % 2 === 1 // Final: show icon ONLY in top row (row 5, not row 6)
                : isR42
                    ? row % 2 === 1
                    : (isOddSlot && row % 2 === 1) || (!isOddSlot && row % 2 === 0);

            // ALWAYS show icon for r2 final in row 5 (top row) - unless MWC2026
            // MWC2026: Skip video icons for all bracket matches
            const isMWC2026 = settings.globals.currentTourny.tournyID === 'MWC2026';
            if (!isMWC2026 && slot === 'r2' && row === 5) {
                // Force icon to show for final in top row
                const isFinal = true;
                const iconClass = 'bracketVideoIconInline'; // Final: icon on right (no -left class)
                const paddingClass = 'bracketScoreWithVideoRight'; // Final: padding for right icon
                const dummyMatchID = 999999;
                textNeeded =
                    '<span class="' +
                    paddingClass +
                    '">' +
                    textNeeded +
                    '<span class="' +
                    iconClass +
                    '" onclick="handleVideo(' +
                    dummyMatchID +
                    ')"></span></span>';
            } else if (!isMWC2026 && shouldShowIcon) {
                // Special case: Final (r2) for 32-team bracket should always have icon to the right of score
                // For other 32-team bracket right side slots (columns 21-35), position left; otherwise position right (default)
                const isFinal = slot === 'r2'; // We're already in the 32-team bracket block, so just check slot
                // For final, always use right positioning; otherwise check isRightSide32Team parameter
                const iconClass = isFinal
                    ? 'bracketVideoIconInline' // Final: icon on right (no -left class)
                    : isRightSide32Team
                        ? 'bracketVideoIconInline bracketVideoIconInline-left' // Other right-side: icon on left
                        : 'bracketVideoIconInline'; // Left-side: icon on right
                // Wrap score text in span with padding to prevent overlap with icon
                const paddingClass = isFinal
                    ? 'bracketScoreWithVideoRight' // Final: padding for right icon
                    : isRightSide32Team
                        ? 'bracketScoreWithVideoLeft' // Other right-side: padding for left icon
                        : 'bracketScoreWithVideoRight'; // Left-side: padding for right icon
                // Use a dummy matchID for the hard-coded icon
                const dummyMatchID = 999999;
                textNeeded =
                    '<span class="' +
                    paddingClass +
                    '">' +
                    textNeeded +
                    '<span class="' +
                    iconClass +
                    '" onclick="handleVideo(' +
                    dummyMatchID +
                    ')"></span></span>';
            }
        } else {
            // Original code for 8-team and 16-team brackets
            if (theTeamID === 'TBD' || theTeamID === null || theTeamID === undefined || !theCurrentMatch)
                textNeeded = '';
            else if (theCurrentMatch.matchCompleted) {
                if (theCurrentMatch.teamOneID === theTeamID) {
                    textNeeded = theCurrentMatch.teamOneScore;
                } else if (theCurrentMatch.teamTwoID === theTeamID) {
                    textNeeded = theCurrentMatch.teamTwoScore;
                } else {
                    // theTeamID doesn't match either team in theCurrentMatch - shouldn't happen but return empty
                    textNeeded = '';
                }
                if (theCurrentMatch.penaltyKickShootout && textNeeded) textNeeded += '*';

                // Add video icon based on slot number:
                // - Odd-numbered slots (1, 3, 5, 7, etc.): icon in top row (row % 2 === 1)
                // - Even-numbered slots (2, 4, 6, 8, etc.): icon in second row (row % 2 === 0)
                // Extract slot number from slot string (e.g., "r16-1" → 1, "r8-2" → 2, "r2" → treat as 1)
                let slotNumber = 1; // Default for final (r2)
                if (slot && slot.includes('-')) {
                    const slotParts = slot.split('-');
                    if (slotParts.length > 1) {
                        slotNumber = parseInt(slotParts[1], 10) || 1;
                    }
                }
                const isOddSlot = slotNumber % 2 === 1;
                // MWC2026: Skip video icons for all bracket matches
                const isMWC2026 = settings.globals.currentTourny.tournyID === 'MWC2026';
                const shouldShowIcon =
                    !isMWC2026 &&
                    hasVideoAvailable(theCurrentMatch) &&
                    ((isOddSlot && row % 2 === 1) || (!isOddSlot && row % 2 === 0));

                if (shouldShowIcon) {
                    // For 32-team bracket right side, position left; otherwise position right (default)
                    const iconClass = isRightSide32Team
                        ? 'bracketVideoIconInline bracketVideoIconInline-left'
                        : 'bracketVideoIconInline';
                    // Wrap score text in span with padding to prevent overlap with icon
                    const paddingClass = isRightSide32Team ? 'bracketScoreWithVideoLeft' : 'bracketScoreWithVideoRight';
                    textNeeded =
                        '<span class="' +
                        paddingClass +
                        '">' +
                        textNeeded +
                        '<span class="' +
                        iconClass +
                        '" onclick="handleVideo(' +
                        theCurrentMatch.matchID +
                        ')"></span></span>';
                }
            } else textNeeded = '';
        }
    }

    if (infoNeeded === 'flag') {
        // TEMPORARY: Hard code USA flag for 32-team bracket only (including r2 final), leave others as-is
        const isThreeRoundsToThirtyTwo =
            settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
        // Show USA flag for all slots in 32-team bracket, including r2 final
        // This must run even if theCurrentMatch is undefined (for subsequent rounds like r2)
        if (isThreeRoundsToThirtyTwo) {
            textNeeded = htmlBuilder.buildFlag('USA', 'bracketFlag', false);
        } else {
            // Original code for 8-team and 16-team brackets
            textNeeded = htmlBuilder.buildFlag(theTeamID, 'bracketFlag', false);
        }
    }
    return textNeeded != null ? textNeeded : '';
}

function getIconSource(theTeamID) {
    if (!settings.globals.currentTourny.dataSources.flagsUseAPI) return './img/countryFlags/' + theTeamID + '.png';
    else return manageData.getTeamLogoFromAPI(theTeamID);
}

function getBracketPiece(row, column) {
    let returnText = null;
    let bracketSlot = null;
    let columnMod = column % 4;
    const isThreeRoundsToThirtyTwo = settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';

    if (isThreeRoundsToThirtyTwo) {
        // For threeRoundsToThirtyTwoKnockOut: symmetrical bracket - same rows for left/right, columns determine side
        // R32 rows: 1,2,5,6,9,10,13,14,17,18,21,22,25,26,29,30 (same rows for both left and right)
        const r32Rows = [1, 2, 5, 6, 9, 10, 13, 14, 17, 18, 21, 22, 25, 26, 29, 30];
        if (r32Rows.includes(row)) {
            const matchIndex = Math.floor(r32Rows.indexOf(row) / 2);
            // Left side: columns 1-3 → r32-1 through r32-8
            // Right side: columns 33-35 → r32-9 through r32-16
            if (column >= 1 && column <= 3) {
                bracketSlot = 'r32-' + (matchIndex + 1);
            } else if (column >= 33 && column <= 35) {
                bracketSlot = 'r32-' + (matchIndex + 9);
            }
        }
        // R16 rows: 3,4,11,12,19,20,27,28 (same rows for both left and right)
        else if ([3, 4, 11, 12, 19, 20, 27, 28].includes(row)) {
            const r16Rows = [3, 4, 11, 12, 19, 20, 27, 28];
            const matchIndex = Math.floor(r16Rows.indexOf(row) / 2);
            // Left side: columns 5-7 → r16-1 through r16-4
            // Right side: columns 29-31 → r16-5 through r16-8
            if (column >= 5 && column <= 7) {
                bracketSlot = 'r16-' + (matchIndex + 1);
            } else if (column >= 29 && column <= 31) {
                bracketSlot = 'r16-' + (matchIndex + 5);
            }
        }
        // Final: rows 5,6 → r2 (columns 15, 18, 21 for flag, name, score)
        // Check Final AFTER R32 because rows 5,6 are also used for R32
        // But Final columns (15, 18, 21) don't overlap with R32 columns (1-3, 33-35), so this is safe
        if ([5, 6].includes(row)) {
            if (column === 15 || column === 18 || column === 21) {
                bracketSlot = 'r2';
            }
        }
        // R8 rows: 7,8,23,24 (same rows for both left and right)
        else if ([7, 8, 23, 24].includes(row)) {
            const r8Rows = [7, 8, 23, 24];
            const matchIndex = Math.floor(r8Rows.indexOf(row) / 2);
            // Left side: columns 9-11 → r8-1, r8-2
            // Right side: columns 25-27 → r8-3, r8-4
            if (column >= 9 && column <= 11) {
                bracketSlot = 'r8-' + (matchIndex + 1);
            } else if (column >= 25 && column <= 27) {
                bracketSlot = 'r8-' + (matchIndex + 3);
            }
        }
        // R4 rows: 15,16 (same rows for both left and right)
        else if ([15, 16].includes(row)) {
            // Left side: columns 13-15 → r4-1
            // Right side: columns 21-23 → r4-2
            if (column >= 13 && column <= 15) {
                bracketSlot = 'r4-1';
            } else if (column >= 21 && column <= 23) {
                bracketSlot = 'r4-2';
            }
        }
    } else {
        // For threeRoundsToSixteenKnockOut or threeRoundsToEightKnockOut or fiveRoundsToEightKnockOut
        const isThreeRoundsToEight = settings.globals.currentTourny.scheduleFormat === 'threeRoundsToEightKnockOut';
        const isFiveRoundsToEight = settings.globals.currentTourny.scheduleFormat === 'fiveRoundsToEightKnockOut';

        if (isThreeRoundsToEight || isFiveRoundsToEight) {
            // For 8-team brackets: r8-* is the FIRST round (not r16-*)
            if (row === 1 || row === 2) bracketSlot = 'r8-1';
            if (row === 5 || row === 6) bracketSlot = 'r8-2';
            if (row === 9 || row === 10) bracketSlot = 'r8-3';
            if (row === 13 || row === 14) bracketSlot = 'r8-4';

            if (row === 3 || row === 4) bracketSlot = 'r4-1';
            if (row === 11 || row === 12) bracketSlot = 'r4-2';

            if (row === 7 || row === 8) bracketSlot = 'r2';
        } else {
            // For 16-team brackets: original row mappings
            if (row === 1 || row === 2) bracketSlot = 'r16-1';
            if (row === 5 || row === 6) bracketSlot = 'r16-2';
            if (row === 9 || row === 10) bracketSlot = 'r16-3';
            if (row === 13 || row === 14) bracketSlot = 'r16-4';
            if (row === 17 || row === 18) bracketSlot = 'r16-5';
            if (row === 21 || row === 22) bracketSlot = 'r16-6';
            if (row === 25 || row === 26) bracketSlot = 'r16-7';
            if (row === 29 || row === 30) bracketSlot = 'r16-8';

            if (row === 3 || row === 4) bracketSlot = 'r8-1';
            if (row === 11 || row === 12) bracketSlot = 'r8-2';
            if (row === 19 || row === 20) bracketSlot = 'r8-3';
            if (row === 27 || row === 28) bracketSlot = 'r8-4';

            if (row === 7 || row === 8) bracketSlot = 'r4-1';
            if (row === 23 || row === 24) bracketSlot = 'r4-2';

            if (row === 15 || row === 16) bracketSlot = 'r2';
        }
    }

    // For threeRoundsToThirtyTwoKnockOut, right side (columns 21-35) has reversed order: score, name, flag
    const isRightSide32Team = isThreeRoundsToThirtyTwo && column >= 21 && column <= 35;

    // Special handling for Final (r2) in rows 5-6: columns 15 (flag), 18 (name), 21 (score)
    const isFinalInRows56 = isThreeRoundsToThirtyTwo && bracketSlot === 'r2' && [5, 6].includes(row);

    if (isFinalInRows56) {
        // Final in rows 5-6: column 15 = flag, column 18 = name, column 21 = score
        if (!bracketSlot) return '';
        if (column === 15) returnText = getBracketInfo(bracketSlot, row, 'flag', false);
        else if (column === 18) returnText = getBracketInfo(bracketSlot, row, 'name', false);
        else if (column === 21) returnText = getBracketInfo(bracketSlot, row, 'score', false);
        else returnText = '';
    } else if (isRightSide32Team) {
        // Right side: reversed order (score, name, flag as we move left to right)
        if (columnMod === 1) returnText = getBracketInfo(bracketSlot, row, 'score', true);
        else if (columnMod === 2) returnText = getBracketInfo(bracketSlot, row, 'name', true);
        else if (columnMod === 3) returnText = getBracketInfo(bracketSlot, row, 'flag', true);
        else returnText = getBracketInfo(bracketSlot, row, 'score', true); // columnMod === 0, treat as score
    } else {
        // Left side and other formats: normal order (flag, name, score)
        if (!bracketSlot) return '';
        if (columnMod === 1) returnText = getBracketInfo(bracketSlot, row, 'flag', false);
        else if (columnMod === 2) returnText = getBracketInfo(bracketSlot, row, 'name', false);
        else returnText = getBracketInfo(bracketSlot, row, 'score', false);
    }
    return returnText != null ? returnText : '';
}

function buildBracket() {
    const isThreeRoundsToEight = settings.globals.currentTourny.scheduleFormat === 'threeRoundsToEightKnockOut';
    const isFiveRoundsToEight = settings.globals.currentTourny.scheduleFormat === 'fiveRoundsToEightKnockOut';
    const isThreeRoundsToThirtyTwo = settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
    // For 36-column layouts, make name columns wider (columns 2,6,10,14,22,26,30,34) and flag/score columns narrower
    // Pattern: flag(2%) name(5.6%) score(2%) spacer(0.25%) repeated, with wider center for final
    let gridColumns;
    if (isThreeRoundsToThirtyTwo) {
        // Name columns reduced by 20% from original 7%: 5.6% -> 4.48% (5.6 * 0.8 = 4.48)
        // Pattern: flag(2%) name(4.48%) score(2%) spacer(0.125%) flag(2%) name(4.48%) score(2%) spacer(0.125%) flag(2%) name(4.48%) score(2%) spacer(0.125%) flag(2%) name(4.48%) score(2%) center...
        // Center columns: 16=0.01%, 17=0.01%, 18=4.48% (Final name only), 19=0.01%, 20=0.01%
        const originalCols =
            '2% 4.48% 2% 0.125% 2% 4.48% 2% 0.125% 2% 4.48% 2% 0.125% 2% 4.48% 2% 0.01% 0.01% 4.48% 0.01% 0.01% 2% 4.48% 2% 0.25% 2% 4.48% 2% 0.25% 2% 4.48% 2% 0.25% 2% 4.48% 2%';
        // Calculate total and scale to 100%
        const vals = originalCols
            .split(/\s+/)
            .filter((s) => s)
            .map((s) => parseFloat(s.replace('%', '')));
        const total = vals.reduce((a, b) => a + b, 0);
        const scaleFactor = 100 / total;
        const scaledCols = originalCols
            .split(/\s+/)
            .filter((s) => s)
            .map((col) => {
                const val = parseFloat(col.replace('%', ''));
                return (val * scaleFactor).toFixed(4) + '%';
            });
        gridColumns = scaledCols.join(' ');
    } else if (isThreeRoundsToEight || isFiveRoundsToEight) {
        // 8-team bracket: only need 11 columns (r8: 1-3, r4: 5-7, r2: 9-11)
        // Pattern: flag(3%) name(10%) score(6%) spacer(5%) flag(3%) name(10%) score(6%) spacer(5%) flag(3%) name(10%) score(6%)
        // Total: 3+10+6+5+3+10+6+5+3+10+6 = 67%
        const originalCols = '3% 10% 6% 5% 3% 10% 6% 5% 3% 10% 6%';
        // Calculate actual sum to get correct scale factor
        const vals = originalCols
            .split(/\s+/)
            .filter((s) => s)
            .map((s) => parseFloat(s.replace('%', '')));
        const total = vals.reduce((a, b) => a + b, 0);
        const scaleFactor = 100 / total; // Scale to 100% based on actual sum
        const isSmallScreen = window.innerWidth <= 768; // Match CSS media query breakpoint
        const scaledCols = originalCols
            .split(/\s+/)
            .filter((s) => s)
            .map((col, idx) => {
                let val = parseFloat(col.replace('%', '')) * scaleFactor;
                // Spacers at indices 3, 7 (columns 4, 8): reduce by 1% (2% total on small screens)
                if (idx === 3 || idx === 7) {
                    val = val - 1;
                    if (isSmallScreen) {
                        val = val - 1; // Additional 1% reduction for small screens
                    }
                }
                // Score columns at indices 2, 6, 10 (columns 3, 7, 11): reduce by 1% on small screens
                // Last score column (idx 10, column 11): reduce width to fit content (score + icon)
                else if (idx === 2 || idx === 6 || idx === 10) {
                    if (isSmallScreen) {
                        val = val - 1; // Reduce by 1% for small screens
                    }
                    // Last score column: reduce width to account for icon not filling column width
                    // This eliminates white space and ensures centering is based on icon's right edge
                    if (idx === 10) {
                        val = val - 2; // Reduce by 2% to fit content better
                    }
                }
                // Name columns at indices 1, 5, 9 (columns 2, 6, 10): add 0.75% (2.5% total on small screens)
                // Adjust first name column slightly to get exactly 100% total
                // Also compensate for last score column reduction
                else if (idx === 1 || idx === 5 || idx === 9) {
                    val = val + 0.75;
                    // Reduce first name column by 0.25% to compensate for net +0.25% from adjustments
                    // Add 2% to compensate for last score column reduction (2% / 3 names ≈ 0.67% each, but distribute to first)
                    if (idx === 1) {
                        val = val - 0.25 + 2; // Compensate for last score column reduction
                    }
                    if (isSmallScreen) {
                        val = val + 0.75; // Additional 0.75% from spacers
                        val = val + 1; // Additional 1% from score columns (3 scores × 1% / 3 names = 1%)
                    }
                }
                return val.toFixed(4) + '%';
            });
        gridColumns = scaledCols.join(' ');
    } else {
        // 16-team bracket: name columns 10%, spacer columns reduced from 10% to 5%
        // Scale columns from 91% to 100%, then adjust: reduce spacers by 1% each, add 0.75% to each name column
        // For small screens (≤768px): reduce spacers by additional 1% each, add 0.75% to each name column,
        // then reduce score columns by 1% each, add 1% to each name column
        const originalCols = '3% 10% 6% 5% 3% 10% 6% 5% 3% 10% 6% 5% 3% 10% 6%';
        const scaleFactor = 100 / 91; // Scale to 100%
        const isSmallScreen = window.innerWidth <= 768; // Match CSS media query breakpoint
        const scaledCols = originalCols
            .split(/\s+/)
            .filter((s) => s)
            .map((col, idx) => {
                let val = parseFloat(col.replace('%', '')) * scaleFactor;
                // Spacers at indices 3, 7, 11 (columns 4, 8, 12): reduce by 1% (2% total on small screens)
                if (idx === 3 || idx === 7 || idx === 11) {
                    val = val - 1;
                    if (isSmallScreen) {
                        val = val - 1; // Additional 1% reduction for small screens
                    }
                }
                // Score columns at indices 2, 6, 10, 14 (columns 3, 7, 11, 15): reduce by 1% on small screens
                else if (idx === 2 || idx === 6 || idx === 10 || idx === 14) {
                    if (isSmallScreen) {
                        val = val - 1; // Reduce by 1% for small screens
                    }
                }
                // Name columns at indices 1, 5, 9, 13 (columns 2, 6, 10, 14): add 0.75% (2.5% total on small screens)
                else if (idx === 1 || idx === 5 || idx === 9 || idx === 13) {
                    val = val + 0.75;
                    if (isSmallScreen) {
                        val = val + 0.75; // Additional 0.75% from spacers
                        val = val + 1; // Additional 1% from score columns (4 scores × 1% / 4 names = 1%)
                    }
                }
                return val.toFixed(4) + '%';
            });
        gridColumns = scaledCols.join(' ');
    }
    const wrapperClass = isThreeRoundsToThirtyTwo
        ? 'wrapper wrapper-32team'
        : isThreeRoundsToEight || isFiveRoundsToEight
            ? 'wrapper wrapper-8team'
            : 'wrapper wrapper-16team';
    // For 8-team brackets, only need 14 rows (4 quarter-finals + 2 semi-finals + 1 final)
    // For 16-team brackets, need 30 rows (8 round-of-16 + 4 quarter-finals + 2 semi-finals + 1 final)
    // For 32-team brackets, need 30 rows
    const maxRows = isThreeRoundsToThirtyTwo ? 30 : isThreeRoundsToEight || isFiveRoundsToEight ? 14 : 30;
    // Set grid-template-rows inline for 8-team brackets (14 rows × ~7.14% each = 100%)
    // For 16-team and 32-team brackets, use CSS default (30 rows)
    const gridRows =
        isThreeRoundsToEight || isFiveRoundsToEight
            ? '7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429% 7.1429%'
            : '';
    const styleAttr = gridRows
        ? 'style="grid-template-columns: ' + gridColumns + '; grid-template-rows: ' + gridRows + ';"'
        : 'style="grid-template-columns: ' + gridColumns + ';"';
    let returnText = '<div class="' + wrapperClass + '" ' + styleAttr + '>';
    for (let m = 1; m <= maxRows; m++) {
        let rowMod2 = m % 2;
        let rowMod4 = m % 4;
        let rowMod8 = m % 8;
        let rowMod16 = m % 16;
        let rowMod32 = m % 32;
        const maxColumns = isThreeRoundsToThirtyTwo ? 36 : isThreeRoundsToEight || isFiveRoundsToEight ? 11 : 15;
        for (let k = 1; k <= maxColumns; k++) {
            let content = '';
            let classAdd = '';
            if (isThreeRoundsToThirtyTwo) {
                // For threeRoundsToThirtyTwoKnockOut: symmetrical bracket - same rows for left/right, different columns
                // R32: rows 1,2,5,6,9,10,13,14,17,18,21,22,25,26,29,30 (same for both sides)
                const r32Rows = [1, 2, 5, 6, 9, 10, 13, 14, 17, 18, 21, 22, 25, 26, 29, 30];
                // R16: rows 3,4,11,12,19,20,27,28 (same for both sides)
                const r16Rows = [3, 4, 11, 12, 19, 20, 27, 28];
                // R8: rows 7,8,23,24 (same for both sides)
                const r8Rows = [7, 8, 23, 24];
                // R4: rows 15,16 (same for both sides)
                const r4Rows = [15, 16];

                // Left R32: columns 1-3
                if ((k === 1 || k === 2 || k === 3) && r32Rows.includes(m)) content = getBracketPiece(m, k);
                // Right R32: columns 33-35
                else if ((k === 33 || k === 34 || k === 35) && r32Rows.includes(m)) content = getBracketPiece(m, k);
                // Left R16: columns 5-7
                else if ((k === 5 || k === 6 || k === 7) && r16Rows.includes(m)) content = getBracketPiece(m, k);
                // Right R16: columns 29-31
                else if ((k === 29 || k === 30 || k === 31) && r16Rows.includes(m)) content = getBracketPiece(m, k);
                // Left R8: columns 9-11
                else if ((k === 9 || k === 10 || k === 11) && r8Rows.includes(m)) content = getBracketPiece(m, k);
                // Right R8: columns 25-27
                else if ((k === 25 || k === 26 || k === 27) && r8Rows.includes(m)) content = getBracketPiece(m, k);
                // Final: rows 5,6 (columns 15, 18, 21 for flag, name, score)
                else if ([5, 6].includes(m) && (k === 15 || k === 18 || k === 21)) content = getBracketPiece(m, k);
                // Left R4: columns 13-15
                else if ((k === 13 || k === 14 || k === 15) && r4Rows.includes(m)) content = getBracketPiece(m, k);
                // Right R4: columns 21-23
                else if ((k === 21 || k === 22 || k === 23) && r4Rows.includes(m)) content = getBracketPiece(m, k);
            } else {
                // For threeRoundsToSixteenKnockOut or threeRoundsToEightKnockOut or fiveRoundsToEightKnockOut
                if (isThreeRoundsToEight || isFiveRoundsToEight) {
                    // For 8-team brackets: r8-* is in columns 1-3, r4-* is in columns 5-7, r2 is in columns 9-11
                    // r8-* rows: 1,2,5,6,9,10,13,14 (rowMod4 === 1 || rowMod4 === 2, but all rows where rowMod4 === 1 || 2)
                    if ((k === 1 || k === 2 || k === 3) && (rowMod4 === 1 || rowMod4 === 2))
                        content = getBracketPiece(m, k);
                    // r4-* rows: 3,4,11,12 (rowMod8 === 3 || rowMod8 === 4, but only top half: rows 3,4 and 11,12)
                    else if ((k === 5 || k === 6 || k === 7) && (m === 3 || m === 4 || m === 11 || m === 12))
                        content = getBracketPiece(m, k);
                    // r2 rows: 7,8 (rowMod16 === 7 || rowMod16 === 8, but only rows 7,8 for 8-team)
                    else if ((k === 9 || k === 10 || k === 11) && (m === 7 || m === 8)) content = getBracketPiece(m, k);
                } else {
                    // For 16-team brackets: keep original structure
                    if ((k === 1 || k === 2 || k === 3) && (rowMod4 === 1 || rowMod4 === 2))
                        content = getBracketPiece(m, k);
                    else if ((k === 5 || k === 6 || k === 7) && (rowMod8 === 3 || rowMod8 === 4))
                        content = getBracketPiece(m, k);
                    else if ((k === 9 || k === 10 || k === 11) && (rowMod16 === 7 || rowMod16 === 8))
                        content = getBracketPiece(m, k);
                    else if ((k === 13 || k === 14 || k === 15) && (rowMod32 === 15 || rowMod32 === 16))
                        content = getBracketPiece(m, k);
                }
            }

            if (isThreeRoundsToThirtyTwo) {
                // Border conditions for threeRoundsToThirtyTwoKnockOut - symmetrical structure
                const r32Rows = [1, 2, 5, 6, 9, 10, 13, 14, 17, 18, 21, 22, 25, 26, 29, 30];
                const r16Rows = [3, 4, 11, 12, 19, 20, 27, 28];
                const r8Rows = [7, 8, 23, 24];
                const r4Rows = [15, 16];

                // Left R32: right border on column 3 (all slots except first and last) - using same logic as 16-team bracket
                // R32 rows: 1,2,5,6,9,10,13,14,17,18,21,22,25,26,29,30
                // Using rowMod8: first slot rows 1,2 (rowMod8 === 1,2), last slot rows 29,30 (rowMod8 === 5,6)
                // Right border on all middle slots: rowMod8 > 1 && rowMod8 < 6
                if (k === 3 && rowMod8 > 1 && rowMod8 < 6) classAdd += 'myBorderRight ';
                // Left R16: right border on column 7 (all slots except first and last) - using same logic as 16-team bracket
                // R16 rows: 3,4,11,12,19,20,27,28
                // Using rowMod16: first slot rows 3,4 (rowMod16 === 3,4), last slot rows 27,28 (rowMod16 === 11,12)
                // Right border on all middle slots: rowMod16 > 3 && rowMod16 < 12
                if (k === 7 && rowMod16 > 3 && rowMod16 < 12) classAdd += 'myBorderRight ';
                // Left R8: right border on column 11 (all slots except first and last) - using same logic as 16-team bracket
                // R8 rows: 7,8,23,24
                // Using rowMod32: first slot rows 7,8 (rowMod32 === 7,8), last slot rows 23,24 (rowMod32 === 23,24)
                // Right border on all middle slots: rowMod32 > 7 && rowMod32 < 24
                if (k === 11 && rowMod32 > 7 && rowMod32 < 24) classAdd += 'myBorderRight ';
                // Left R4: right border on column 15 (only one slot, so no right border needed)
                // R4 rows: 15,16 (only r4-1)
                // No right border for single slot

                // Right side left borders - using same logic as left side right borders
                // Right R32: left border on column 33 (leftmost column of right R32) - all slots except first and last
                // Using rowMod8: first slot rows 1,2 (rowMod8 === 1,2), last slot rows 29,30 (rowMod8 === 5,6)
                // Left border on all middle slots: rowMod8 > 1 && rowMod8 < 6
                if (k === 33 && rowMod8 > 1 && rowMod8 < 6) classAdd += 'myBorderLeft ';
                // Right R16: left border on column 29 (leftmost column of right R16) - all slots except first and last
                // Using rowMod16: first slot rows 3,4 (rowMod16 === 3,4), last slot rows 27,28 (rowMod16 === 11,12)
                // Left border on all middle slots: rowMod16 > 3 && rowMod16 < 12
                if (k === 29 && rowMod16 > 3 && rowMod16 < 12) classAdd += 'myBorderLeft ';
                // Right R8: left border on column 25 (leftmost column of right R8) - all slots except first and last
                // Using rowMod32: first slot rows 7,8 (rowMod32 === 7,8), last slot rows 23,24 (rowMod32 === 23,24)
                // Left border on all middle slots: rowMod32 > 7 && rowMod32 < 24
                if (k === 25 && rowMod32 > 7 && rowMod32 < 24) classAdd += 'myBorderLeft ';
                // Right R4: left border on column 21 (leftmost column of right R4) - only one slot, so no left border
                // R4 rows: 15,16 (only r4-2)
                // No left border for single slot

                // Transition borders (spacer columns between rounds)
                // Left side: column 4 (between R32 and R16)
                if (
                    k === 4 &&
                    (m === 2 || m === 6 || m === 10 || m === 14 || m === 18 || m === 22 || m === 26 || m === 30)
                )
                    classAdd += 'myBorderBottom ';
                // Left side: column 8 (between R16 and R8)
                else if (k === 8 && (m === 4 || m === 12 || m === 20 || m === 28)) classAdd += 'myBorderBottom ';
                // Left side: column 12 (between R8 and R4)
                else if (k === 12 && (m === 8 || m === 24)) classAdd += 'myBorderBottom ';
                // Columns 16-20 (Final/center) have no borders
                // Right side transition borders - REMOVED for clean start
                // Right side: column 24 (between R4 and R8)
                // else if (k === 24 && (m === 8 || m === 24)) classAdd += 'myBorderBottom ';
                // Right side: column 28 (between R8 and R16)
                // else if (k === 28 && (m === 4 || m === 12 || m === 20 || m === 28)) classAdd += 'myBorderBottom ';
                // Right side: column 32 (between R16 and R32)
                // else if (
                //     k === 32 &&
                //     (m === 2 || m === 6 || m === 10 || m === 14 || m === 18 || m === 22 || m === 26 || m === 30)
                // )
                //     classAdd += 'myBorderBottom ';

                // Top/bottom borders - remove top from odd slots, remove bottom from even slots
                // Top border should be below the first row of the slot (on the second/even row)
                // Left R32: columns 1-3
                // Determine slot number: rows 1,2=r32-1, rows 5,6=r32-2, rows 9,10=r32-3, rows 13,14=r32-4,
                // rows 17,18=r32-5, rows 21,22=r32-6, rows 25,26=r32-7, rows 29,30=r32-8
                if (k === 3 && r32Rows.includes(m)) {
                    const matchIndex = Math.floor(r32Rows.indexOf(m) / 2);
                    const slotNum = matchIndex + 1; // r32-1 through r32-8
                    // Top border only on even-numbered slots (r32-2, r32-4, r32-6, r32-8) - below first row
                    // Top border below rows 5, 13, 21, 29 (on rows 6, 14, 22, 30)
                    if (slotNum % 2 === 0 && (m === 6 || m === 14 || m === 22 || m === 30)) {
                        classAdd += 'myBorderTop ';
                    }
                    // Bottom border on odd-numbered slots (r32-1, r32-3, r32-5, r32-7) - on first row (rows 1, 9, 17, 25)
                    // NOT on second row (rows 2, 10, 18, 26)
                    if (slotNum % 2 === 1 && (m === 1 || m === 9 || m === 17 || m === 25)) {
                        classAdd += 'myBorderBottom ';
                    }
                    // Bottom border on even rows (second row of each slot) for odd-numbered slots - remove this
                    // if (slotNum % 2 === 1 && (m === 2 || m === 10 || m === 18 || m === 26)) {
                    //     classAdd += 'myBorderBottom ';
                    // }
                }
                // Left R16: columns 5-7
                // Rows 3,4=r16-1, rows 11,12=r16-2, rows 19,20=r16-3, rows 27,28=r16-4
                if (k === 7 && r16Rows.includes(m)) {
                    const matchIndex = Math.floor(r16Rows.indexOf(m) / 2);
                    const slotNum = matchIndex + 1; // r16-1 through r16-4
                    // Top border only on even-numbered slots (r16-2, r16-4) - below first row (on even rows)
                    if (slotNum % 2 === 0 && (m === 12 || m === 20 || m === 28)) {
                        classAdd += 'myBorderTop ';
                    }
                    // Bottom border on odd-numbered slots (r16-1, r16-3) - on first row (rows 3, 19)
                    if (slotNum % 2 === 1 && (m === 3 || m === 19)) {
                        classAdd += 'myBorderBottom ';
                    }
                }
                // Left R8: columns 9-11
                // Rows 7,8=r8-1, rows 23,24=r8-2
                if (k === 11 && r8Rows.includes(m)) {
                    const matchIndex = Math.floor(r8Rows.indexOf(m) / 2);
                    const slotNum = matchIndex + 1; // r8-1, r8-2
                    // Top border only on even-numbered slots (r8-2) - below first row (on even row)
                    if (slotNum % 2 === 0 && m === 24) {
                        classAdd += 'myBorderTop ';
                    }
                    // Bottom border on odd-numbered slots (r8-1) - on first row (row 7), not on second row (row 8)
                    if (slotNum % 2 === 1 && m === 7) {
                        classAdd += 'myBorderBottom ';
                    }
                }
                // Left R4: columns 13-15 (only one slot)
                // Remove top border from row 15 and bottom border from row 16
                // No borders for R4
                // Final (r2): columns 16-20 - no borders

                // Right side borders - using same logic as left side (same rows, different columns)
                // Only apply to score columns (leftmost column of each round on right side, which has score and video icon)
                // Right side has reversed order: score, name, flag (as we move left to right)
                // Right R32: column 33 (score column, leftmost) - r32-9 through r32-16
                // Determine slot number: rows 1,2=r32-9, rows 5,6=r32-10, rows 9,10=r32-11, rows 13,14=r32-12,
                // rows 17,18=r32-13, rows 21,22=r32-14, rows 25,26=r32-15, rows 29,30=r32-16
                if (k === 33 && r32Rows.includes(m)) {
                    const matchIndex = Math.floor(r32Rows.indexOf(m) / 2);
                    const slotNum = matchIndex + 9; // r32-9 through r32-16
                    // Top border on even-numbered slots (r32-10, r32-12, r32-14, r32-16) - below first row (rows 6, 14, 22, 30)
                    if (slotNum % 2 === 0 && (m === 6 || m === 14 || m === 22 || m === 30)) {
                        classAdd += 'myBorderTop ';
                    }
                    // Bottom border on odd-numbered slots (r32-9, r32-11, r32-13, r32-15) - on first row (rows 1, 9, 17, 25)
                    if (slotNum % 2 === 1 && (m === 1 || m === 9 || m === 17 || m === 25)) {
                        classAdd += 'myBorderBottom ';
                    }
                }
                // Right R16: column 29 (score column, leftmost) - r16-5 through r16-8
                // Rows 3,4=r16-5, rows 11,12=r16-6, rows 19,20=r16-7, rows 27,28=r16-8
                if (k === 29 && r16Rows.includes(m)) {
                    const matchIndex = Math.floor(r16Rows.indexOf(m) / 2);
                    const slotNum = matchIndex + 5; // r16-5 through r16-8
                    // Top border on even-numbered slots (r16-6, r16-8) - below first row (rows 12, 28)
                    if (slotNum % 2 === 0 && (m === 12 || m === 28)) {
                        classAdd += 'myBorderTop ';
                    }
                    // Bottom border on odd-numbered slots (r16-5, r16-7) - on first row (rows 3, 19)
                    if (slotNum % 2 === 1 && (m === 3 || m === 19)) {
                        classAdd += 'myBorderBottom ';
                    }
                }
                // Right R8: column 25 (score column, leftmost) - r8-3, r8-4
                // Rows 7,8=r8-3, rows 23,24=r8-4
                if (k === 25 && r8Rows.includes(m)) {
                    const matchIndex = Math.floor(r8Rows.indexOf(m) / 2);
                    const slotNum = matchIndex + 3; // r8-3, r8-4
                    // Top border on even-numbered slots (r8-4) - below first row (row 24)
                    if (slotNum % 2 === 0 && m === 24) {
                        classAdd += 'myBorderTop ';
                    }
                    // Bottom border on odd-numbered slots (r8-3) - on first row (row 7)
                    if (slotNum % 2 === 1 && m === 7) {
                        classAdd += 'myBorderBottom ';
                    }
                }
                // Right R4: column 21 (score column, leftmost) - only one slot, so no borders
                // R4 rows: 15,16 (only r4-2)
                // No borders for R4
            } else {
                // Border conditions for threeRoundsToSixteenKnockOut and threeRoundsToEightKnockOut
                if (k === 4 && rowMod8 === 3) classAdd += 'myBorderBottom ';
                else if (k === 8 && rowMod16 === 7) classAdd += 'myBorderBottom ';
                else if (k === 12 && m === 15) classAdd = 'myBorderBottom ';

                if (k === 3 && rowMod8 > 1 && rowMod8 < 6) classAdd += 'myBorderRight ';
                if (k === 7 && rowMod16 > 3 && rowMod16 < 12) classAdd += 'myBorderRight ';

                //if (k === 3 && rowMod8 === 2 && !isThreeRoundsToEight && !isFiveRoundsToEight) classAdd += 'myBorderTop ';
                if (!isThreeRoundsToEight && !isFiveRoundsToEight && k === 11 && rowMod32 > 7 && rowMod32 < 24)
                    classAdd += 'myBorderRight ';

                if (k === 3 && rowMod8 === 2) classAdd += 'myBorderTop ';
                if (k === 3 && rowMod8 === 5) classAdd += 'myBorderBottom ';
                if (k === 7 && rowMod16 === 4) classAdd += 'myBorderTop ';
                if (k === 7 && rowMod16 === 11) classAdd += 'myBorderBottom ';
                if (!isThreeRoundsToEight && !isFiveRoundsToEight && k === 11 && rowMod32 === 8)
                    classAdd += 'myBorderTop ';
                if (k === 11 && rowMod32 === 23) classAdd += 'myBorderBottom ';
            }

            // Note: We no longer add classes to box for padding to avoid shifting grid boundaries
            // Padding is handled via .bracketScoreWithVideoRight/Left classes on the score span

            // Add class for top row of each match pair (odd rows)
            const isTopRow = m % 2 === 1;
            const topRowClass = isTopRow ? ' bracketTopRow' : '';
            returnText +=
                '<div class="box' +
                topRowClass +
                ' ' +
                classAdd +
                '" style="grid-row: ' +
                m +
                '; grid-column: ' +
                k +
                ';">' +
                content +
                '</div>';
        }
    }

    returnText += '</div>';
    leftBar.innerHTML = returnText;
}

export { buildBracket, getIconSource };
